import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQItemm from './FAQItemm';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Morachichincholibestplace() {



    const cardData =
    {
        keyword: 'Morachi Chincholi Best Place Near Pune for Short Visit',
        heading: 'Anand Krushi Paryatan Kendra: Morachi Chincholi Best Place Near Pune for Short Visit',
        headingDescription: 'Looking for a peaceful rural escape? Anand Krushi Paryatan Kendra is truly the Morachi Chincholi best place near Pune for short visit. Located just 55 km from the city, this 40-acre agri-tourism farm is perfect for families, school trips, and corporate outings seeking a quick, refreshing break from urban life. The center offers a full day of engaging experiences including bullock cart and tractor rides, horse riding, boating, swimming, and a fun-filled rain dance. Guests can also enjoy traditional village games, puppet shows, and magic performances, making it ideal for all age groups.',

        top: 'Top Activities at Anand Krushi Paryatan Kendra:',

topPlaces: [
  {
    "title": "Morachi Chincholi – Peacock Village",
    "description": "Just 55 km from Pune, Morachi Chincholi is the perfect rural escape for nature lovers. Known for its free-roaming peacocks, this peaceful village offers a unique blend of birdwatching, bullock cart rides, village games, and scenic farms."
  },
  {
    "title": "Anand Krushi Paryatan Kendra",
    "description": "Located within Morachi Chincholi, this 40-acre agro-tourism farm offers family-friendly activities like tractor safaris, hands-on farming, pottery workshops, splash zones, rain dance, and unlimited Maharashtrian thali meals — all in a green, peaceful setting."
  },
  {
    "title": "Ranjangaon Mahaganpati Temple",
    "description": "About 30 minutes from Morachi Chincholi, this sacred temple is one of the Ashtavinayak Ganpatis. A peaceful spiritual stop known for its rich heritage and divine architecture."
  },
  {
    "title": "Ghod River Backwaters",
    "description": "A nearby hidden gem ideal for quick relaxation. Enjoy riverside picnics, soft breezes, and birdwatching — great for couples and families looking for peace away from city crowds."
  },
  {
    "title": "Tulapur Historical Ghat",
    "description": "Visit the confluence of Bhima and Indrayani rivers, where Chhatrapati Sambhaji Maharaj was martyred. A meaningful place blending history, nature, and spirituality."
  }
],




"services": [
  {
    "name": "Top Places Near Pune for Short Visits",
    "description": "Anand Krushi Paryatan Kendra stands out as one of the top places near Pune for a short, refreshing visit. Just a couple of hours from the city, it offers lush green surroundings, fun farm activities, and delicious local food—ideal for couples, families, or solo travelers looking for a peaceful day away."
  },
  {
    "name": "Morachi Chincholi One-Day Visit Ideas",
    "description": "Plan a one-day visit to Morachi Chincholi and spend your time at Anand Krushi Paryatan Kendra enjoying peacock sightings, rural games, nature walks, and a traditional farm-to-plate meal—no overnight stay required."
  },
  {
    "name": "Quick Nature Escapes from Pune",
    "description": "Get away from traffic and stress with a quick nature escape to Anand Krushi Paryatan Kendra. Relax under mango trees, walk through fields, and soak in rural views—all just 2 hours from Pune."
  },
  {
    "name": "Weekend Visit Near Morachi Chincholi",
    "description": "Make the most of your weekend with a short visit to Anand Krushi Paryatan Kendra. With peaceful landscapes, light adventure activities, and organic meals, it’s an ideal break for individuals or groups."
  },
  {
    "name": "Short Countryside Trips Near Pune",
    "description": "Escape to the countryside without a long journey. Anand Krushi Paryatan Kendra offers a real taste of rural life with easy access, making it perfect for short countryside trips from Pune."
  },
  {
    "name": "Best Scenic Locations Near Morachi Chincholi",
    "description": "Enjoy scenic beauty with lush fields, flower patches, and clear skies. The farm's natural charm makes it one of the best visual spots near Morachi Chincholi for a relaxing and photogenic visit."
  },
  {
    "name": "Day Sightseeing Options Near Pune",
    "description": "Include Anand Krushi Paryatan Kendra in your day sightseeing plan. Combine your visit with nearby temples, markets, or nature spots, and wrap it up with a rural lunch and farm fun."
  },
  {
    "name": "Peaceful Short Trips Near Morachi Chincholi",
    "description": "Looking for peace and silence? Anand Krushi Paryatan Kendra is a calm retreat where you can read a book, take a nap in a hammock, or stroll quietly through organic farms—perfect for mental recharge."
  },
  {
    "name": "Hidden Gems Near Pune for a Quick Visit",
    "description": "Away from typical tourist crowds, Anand Krushi Paryatan Kendra is a hidden gem offering authentic experiences, clean air, and beautiful views—ideal for travelers who like discovering offbeat spots."
  },
  {
    "name": "Morachi Chincholi Travel Ideas for Short Trips",
    "description": "Explore Morachi Chincholi with a visit to Anand Krushi Paryatan Kendra, where you can see free-roaming peacocks, taste fresh Aamras, and take part in hands-on rural activities during your short trip."
  },
  {
    "name": "Places for Short Family Outings Near Pune",
    "description": "Families love Anand Krushi Paryatan Kendra for its mix of open space, farm games, local food, and child-safe zones—making it one of the top spots near Pune for short family outings."
  },
  {
    "name": "Morachi Chincholi Places to Relax for a Day",
    "description": "Need a relaxing break? Spend your day at Anand Krushi Paryatan Kendra enjoying fresh food, breezy sit-outs, and green spaces—just what you need to relax and refresh."
  },
  {
    "name": "Best Rural Experiences Near Pune",
    "description": "Experience the charm of rural Maharashtra with bullock cart rides, crop tours, mud play zones, and interactive farming demos—all available in a few hours at Anand Krushi Paryatan Kendra."
  },
  {
    "name": "Quick Nature Break from Pune",
    "description": "When you want nature but don't have time for a long trip, Anand Krushi Paryatan Kendra offers a quick yet complete nature break—green surroundings, birdsong, and fresh air just around the corner."
  },
  {
    "name": "Short Travel Getaways from the City",
    "description": "Perfect for last-minute plans, Anand Krushi Paryatan Kendra is a quick getaway from Pune that blends nature, tradition, and simple fun—all in a few relaxed hours on the farm."
  }
],
"tableData": [
  ["Top Places Near Pune for Short Visits", "- Morachi Chincholi One-Day Visit Ideas"],
  ["Quick Nature Escapes from Pune", "- Weekend Visit Near Morachi Chincholi"],
  ["Short Countryside Trips Near Pune", "- Best Scenic Locations Near Morachi Chincholi"],
  ["Day Sightseeing Options Near Pune", "- Peaceful Short Trips Near Morachi Chincholi"],
  ["Hidden Gems Near Pune for a Quick Visit", "- Morachi Chincholi Travel Ideas for Short Trips"],
  ["Places for Short Family Outings Near Pune", "- Morachi Chincholi Places to Relax for a Day"],
  ["Best Rural Experiences Near Pune", "- Quick Nature Break from Pune"],
  ["Short Travel Getaways from the City", "- "]
],



"whychoose": [
  {
    "WhyChooseheading": "Unique Peacock Habitat",
    "WhyChoosedescription": "Morachi Chincholi is famously known as the 'Peacock Village,' where thousands of peacocks roam freely in their natural habitat among sprawling ancient tamarind trees. Visitors can experience the mesmerizing sight of peacocks dancing, calling, and interacting, especially during early mornings and evenings, making it a rare and enchanting wildlife encounter just a short drive from Pune."
  },
  {
    "WhyChooseheading": "Anand Krushi Paryatan Kendra - Authentic Agro Tourism",
    "WhyChoosedescription": "This nearby agro-tourism center offers a perfect blend of rural charm and engaging activities. Visitors can enjoy bullock cart rides, tractor tours, animal feeding, organic farm walks, and savor traditional Maharashtrian farm-to-table meals. It provides an immersive experience into village life and farming practices, ideal for families and groups looking for a meaningful short visit."
  },
  {
    "WhyChooseheading": "Scenic Countryside Drive",
    "WhyChoosedescription": "The journey to Morachi Chincholi from Pune offers picturesque views of lush farmland, rolling hills, and quaint villages. The scenic drive itself is relaxing and sets the tone for a peaceful day out away from city noise and traffic."
  },
  {
    "WhyChooseheading": "Family-Friendly Activities",
    "WhyChoosedescription": "With open spaces and safe environments, Morachi Chincholi is perfect for families. Children can enjoy outdoor play areas, pony rides, and interactive sessions with farm animals, while adults can participate in traditional games, nature walks, and cultural programs."
  },
  {
    "WhyChooseheading": "Proximity and Convenience",
    "WhyChoosedescription": "Located only about 55 km from Pune, Morachi Chincholi is easily accessible for half-day or full-day trips. Its proximity means minimal travel time, allowing visitors to maximize their leisure and exploration time."
  },
  {
    "WhyChooseheading": "Seasonal Festivities and Events",
    "WhyChoosedescription": "Visitors can time their trips to coincide with local festivals like the Mango Mahotsav and Hurda Parties, which celebrate seasonal harvests with traditional food, music, and cultural performances, offering an authentic glimpse into rural Maharashtrian life."
  }
]















    }

const faqData = [
  {
    id: 'FAQ1',
    question: 'Why is Morachi Chincholi considered a top short-visit destination from Pune?',
    answer: 'It’s just 65 km from Pune and offers unique rural experiences like peacock sightings, farm tours, and traditional food, perfect for a refreshing half or full-day escape.',
  },
  {
    id: 'FAQ2',
    question: 'What makes it different from other picnic spots near Pune?',
    answer: 'Unlike commercial resorts, Morachi Chincholi blends nature and tradition—where you can watch peacocks, enjoy bullock cart rides, and experience true village hospitality.',
  },
  {
    id: 'FAQ3',
    question: 'How much time should I plan for a visit to Morachi Chincholi?',
    answer: 'A half-day to one full day is ideal to explore the village, enjoy farm activities, and have lunch before heading back.',
  },
  {
    id: 'FAQ4',
    question: 'Are there any specific attractions or centers to visit?',
    answer: 'Yes, Anand Krushi Paryatan Kendra is one of the most popular agro-tourism centers offering a full rural tourism experience including meals and nature walks.',
  },
  {
    id: 'FAQ5',
    question: 'Can I spot peacocks during a short visit?',
    answer: 'Yes! Visit early morning or late afternoon for the best chance to see peacocks in their natural habitat, especially during monsoon and winter.',
  },
  {
    id: 'FAQ6',
    question: 'Is it family-friendly for a quick weekend trip?',
    answer: 'Absolutely. It’s peaceful, safe, and offers lots of open space and fun activities for kids and adults alike.',
  },
  {
    id: 'FAQ7',
    question: 'Do I need to book in advance for a short visit?',
    answer: 'It’s recommended to call ahead, especially on weekends, to reserve lunch or group activities at the agro-tourism centers.',
  },
  {
    id: 'FAQ8',
    question: 'Is the village accessible by car or bike?',
    answer: 'Yes. Morachi Chincholi is easily accessible by well-connected roads via Alandi or Chakan, suitable for both two- and four-wheelers.',
  },
  {
    id: 'FAQ9',
    question: 'What kind of food is available during the visit?',
    answer: 'You’ll find traditional Maharashtrian meals made from fresh farm ingredients—simple, tasty, and locally sourced.',
  },
  {
    id: 'FAQ10',
    question: 'What’s the best time of year to visit?',
    answer: 'Monsoon to early winter (June to November) is ideal for greenery, cool weather, and high peacock activity.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rahul Pawar, Pune',
    feedback: "For a short and peaceful getaway, Morachi Chincholi is the best! The natural beauty, simple food, and the sight of peacocks made our day special.",
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Aarti Kulkarni, Kothrud',
    feedback: "We did a half-day trip to Morachi Chincholi from Pune. It was a calm, scenic, and unique village experience—perfect for a short break from city life.",
    rating: 5,
  },
];


















    const carouselItems = testimonials.map(testimonial => (
        <div key={testimonial.name}>
            <blockquote>

                <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
                <footer className=' user'>— {testimonial.name}</footer>
            </blockquote>
        </div>
    ));

    const carouselOptions = {
        loop: true,
        margin: 10,
        nav: true,
        items: 1
    };

    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9689125047",
            "+91 9623755047",
            "+91 9673132497",


        ],
        email: "thopatemala@gmail.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "One Day Picnic Spot Near Pune for Family",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "One Day Trip Near Pune",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Picnic Spot Near Pune ",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Picnic Destination Near Pune ",
        },
        {
            place: "/images/keyword/5.jpg",
            text: " Corporate Outing Resorts Near Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Agri Tourism Near Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Destination Wedding Near Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Hurda Party Places Near Pune",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Water Park Near Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "School Picnic Spots Near Pune for Students",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "One Day Adventure Resorts Near Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Resort Near Pune ",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Forest Resorts Near Pune ",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Nature resorts near pune for weekend",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Mango Mahotsav in Pune",
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Krushi Paryatan Kendra near Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Camping Places Near Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Activities Resort Near Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Agro Tourism Near Mumbai for Family",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "One Day Picnic Spot From Mumbai",
        },
        {
            place: "/images/keyword/21.jpg",
            text: "One Day Picnic Packages Near Mumbai",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "School Picnic Spots in Mumbai",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Resort Near Mumbai ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Team Outing Places Near Mumbai",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Corporate Outing Near Mumbai",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Picnic Spot Near Nashik",
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Farm House On Rent in Pune ",
        },
    ];


    const images = [
        { src: "/images/gallery/01.jpg", alt: "Image 1" },
        { src: "/images/gallery/02.jpg", alt: "Image 1" },
        { src: "/images/gallery/03.jpg", alt: "Image 1" },
        { src: "/images/gallery/04.jpg", alt: "Image 1" },
        { src: "/images/gallery/05.jpg", alt: "Image 1" },
        { src: "/images/gallery/06.jpg", alt: "Image 1" },
        { src: "/images/gallery/07.jpg", alt: "Image 1" },
        { src: "/images/gallery/08.jpg", alt: "Image 1" },
        { src: "/images/gallery/09.jpg", alt: "Image 1" },
        { src: "/images/gallery/010.jpg", alt: "Image 1" },
        { src: "/images/gallery/011.jpg", alt: "Image 1" },
        { src: "/images/gallery/012.jpg", alt: "Image 1" },

    ];


const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Morachi Chincholi Best Place Near Pune for Short Visit",
  "image": "https://morachichincholi.in/assets/images/best-place-short-visit-morachi-chincholi.jpg",
  "description": "Discover Morachi Chincholi as the best place near Pune for short visits. Enjoy quick nature escapes, scenic locations, countryside trips, family outings, rural experiences, and peaceful day getaways perfect for weekend breaks.",
  "brand": {
    "@type": "Brand",
    "name": "Anand Krushi Paryatan Kendra"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "1987"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "590",
    "availability": "https://schema.org/InStock",
    "url": "https://morachichincholi.in/best-place-short-visit"
  }
};



    return (
        <div>
<Helmet>
  <title>Morachi Chincholi Best Place Near Pune for Short Visit | Quick Nature Escapes & Scenic Spots</title>
  <meta 
    name="description" 
    content="Morachi Chincholi is the best place near Pune for short visits, offering quick nature escapes, scenic locations, countryside trips, and family-friendly day outings perfect for relaxing weekends." 
  />
  <meta 
    name="keywords" 
    content="Top places near Pune for short visits, Morachi Chincholi one-day visit ideas, Quick nature escapes from Pune, Weekend visit near Morachi Chincholi, Short countryside trips near Pune, Best scenic locations near Morachi Chincholi, Day sightseeing options near Pune, Peaceful short trips near Morachi Chincholi, Hidden gems near Pune for a quick visit, Morachi Chincholi travel ideas for short trips, Places for short family outings near Pune, Morachi Chincholi places to relax for a day, Best rural experiences near Pune, Quick nature break from Pune, Short travel getaways from the city" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <section className="breadcrumb-main pb-20 pt-14" style={{ backgroundImage: 'url(images/bg/bg1.jpg)' }}>
                <div className="section-shape section-shape1 top-inherit bottom-0" style={{ backgroundImage: 'url(images/shape8.png)' }}></div>
                <div className="breadcrumb-outer">
                    <div className="container">
                        <div className="breadcrumb-content text-center">
                            <h1 className="mb-3"> {cardData.keyword}</h1>

                        </div>
                    </div>
                </div>
                <div className="dot-overlay"></div>
            </section>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/18.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#609F31', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3 darkcolor'> Why Choose Anand Krushi Paryatan Kendra for {cardData.keyword + " Rates"}</h3>
                            {/* <BusRatesTable /> */}

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 darkcolor"> {item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">fAQS {cardData.keyword} For Anand Krushi Paryatan Kendra</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                {faqData.map((faq) => (
                                                    <FAQItemm key={faq.id} id={faq.id} question={faq.question} answer={faq.answer} />
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <div>

                                <div className="contact-box Borderr">
                                    <h3 className='darkcolor'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Gallery</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image py-1"

                                            />
                                        </div>
                                    ))}
                                    {/* <Link to='/gallery' className=' border radius-5 bg-redd p-3 text-white rounded-5 '>
                    See Gallery
                  </Link> */}
                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #609F31',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#609F31' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2 text-white"></i>
                                            <div className=''>
                                                <a href="tel:+919689125047" className="d-block  text-white">+91 9689125047</a>
                                                <a href="tel:+919623755047" className="d-block  text-white">+91 9623755047</a>
                                                <a href="tel:+919673132497" className="d-block  text-white">+91 9673132497</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">

                                            <div className='rounded py-2' style={{ backgroundColor: '#609F31' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <i className="bi bi-envelope fs-1 mb-2 text-white"></i>
                                                <a href="mailto:thopatemala@gmail.com" className=" text-white d-block">
                                                    thopatemala@gmail.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">

                                            <div className='rounded py-2' style={{ backgroundColor: '#609F31' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <i className="bi bi-house-fill fs-1 mb-2 text-white"></i>
                                                <p className="whit text-white ">
                                                    <i> Anand Krushi Paryatan Kendra <br />
                                                        Dattatraya Anandrao Thopate, Topate Vasti, Chincholi Morachi, Tal. Shirur, Dist. Pune. Maharashtra - 412218

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Morachichincholibestplace;